$('.coll_slider').slick({
  dots: true,
  infinite: true,
  arrows:true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,

    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows:false   
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 3,
      arrows:false,
      centerMode: true,
      centerPadding: '40px'

    }
  }]
});
$('.category-slider').slick({
  dots: false,
  infinite: true,
  draggable: false,
  arrows:false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 3000,
  autoplay: true
});
$('.slideshow-container').slick({
  dots: true,
  infinite: true,
  arrows:false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 7000,
  autoplay: true,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
	  arrows:false
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false  
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false
    }
  }]
});
$('.quotes-slider').slick({
  dots: true,
  infinite: true,
  arrows:false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplaySpeed: 6000,
  autoplay: true,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
	  arrows:true
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:true   
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true
    }
  }]
});

$('.landing-collection-slider').slick({
  dots: true,
  infinite: true,
  arrows:true,
  speed: 500,
  arrows:true,
  slidesToShow: 4,
  slidesToScroll: 2,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 2,

    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:false   
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:false,
      centerMode: true,
      centerPadding: '40px'

    }
  }]
});
$('.collection-slider').slick({
  dots: true,
  infinite: true,
  arrows:true,
  speed: 500,
  arrows:true,
  slidesToShow: 4,
  slidesToScroll: 2,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 2,

    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:false   
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:false,
      centerMode: true,
      centerPadding: '40px'

    }
  }]
});
$('.coll_slider1').slick({
  dots: true,
  infinite: true,
  arrows:false,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,

    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:false   
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows:false
     /* centerMode: true,
      centerPadding: '40px'*/

    }
  }]
});


$(window).scroll(function(){
  var scrollPos = $(document).scrollTop();
  if(scrollPos > 0) {
//     $(".category-header-section").addClass('hide');
    $("#shopify-section-header").addClass('scroll');
    $(".site-header").addClass('scroll');
  }
  else {
//     $(".category-header-section").removeClass('hide');
    $("#shopify-section-header").removeClass('scroll');
    $(".site-header").removeClass('scroll');
  }
});
